export const getLiveSessionCreditsText = ({ currentCredits, totalCredits }) => {
  if (currentCredits <= 0) return `${totalCredits}/${totalCredits}`
  return `${totalCredits - currentCredits}/${totalCredits}`
}
